import { generateClient } from 'aws-amplify/api'
import { getPlatformDisclaimerDefault as getPlatformDisclaimerDefaultQuery } from '@/graphql/queries'
import { parseAwsJson } from '@/utils/graphql'
import { getApiMessage } from '@/mixins/Extras/ApiResponse'

const client = generateClient()

/** Platform default disclaimer text, for auto-populating when an org first enables it. */
export async function fetchPlatformDisclaimerDefault() {
  try {
    const { data, errors } = await client.graphql({ query: getPlatformDisclaimerDefaultQuery })
    if (errors?.length) throw new Error(errors[0].message)
    return parseAwsJson(data?.getPlatformDisclaimerDefault) || { status: 'ERROR', disclaimer_text: '' }
  } catch (error) {
    return {
      status: 'ERROR',
      disclaimer_text: '',
      message: getApiMessage(error, 'Failed to load default disclaimer'),
    }
  }
}
